import { render, staticRenderFns } from "./CveVulnerability.vue?vue&type=template&id=2533b11c&"
import script from "./CveVulnerability.vue?vue&type=script&lang=js&"
export * from "./CveVulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports